import React from "react";
import { Archive, Play } from "lucide-react";

type ActiveTab = "retention" | "streaming";

interface RetentionDurationTabsProps {
  activeTab: ActiveTab;
  onChange: (tab: ActiveTab) => void;
}

const tabClassName = (isActive: boolean) =>
  `flex items-center justify-center md:gap-2 gap-1 py-2.5 rounded-xl shadow-sm border transition-colors font-medium text-sm md:text-base flex-1 md:flex-none md:w-48 w-full ${
    isActive
      ? "bg-blue-50 border-blue-500 text-blue-600"
      : "bg-white border-gray-200 text-slate-700 hover:bg-blue-50 hover:border-blue-300 hover:text-blue-600"
  }`;

const RetentionDurationTabs: React.FC<RetentionDurationTabsProps> = ({
  activeTab,
  onChange,
}) => {
  return (
    <div className="mb-6 flex space-x-2 w-full">
      <button
        onClick={() => onChange("retention")}
        className={tabClassName(activeTab === "retention")}
      >
        <Archive className="w-4 h-4 flex-shrink-0" />
        <span>Retention Settings</span>
      </button>

      <button
        onClick={() => onChange("streaming")}
        className={tabClassName(activeTab === "streaming")}
      >
        <Play className="w-4 h-4 flex-shrink-0" />
        <span>Stream Settings</span>
      </button>
    </div>
  );
};

export default RetentionDurationTabs;
